import { render } from "./PatientLanguage.vue?vue&type=template&id=5283d9b6&ts=true"
import script from "./PatientLanguage.ts?vue&type=script&lang=ts&external"
export * from "./PatientLanguage.ts?vue&type=script&lang=ts&external"

import "./PatientLanguage.vue?vue&type=style&index=0&id=5283d9b6&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__